import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { AuthAPI } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import logger from "@/lib/logger";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  // Use a ref (not state) so the flag is set synchronously, preventing StrictMode double-run.
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const idx = hash.indexOf("session_id=");
    if (idx === -1) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = hash.substring(idx + "session_id=".length).split("&")[0];

    (async () => {
      try {
        const data = await AuthAPI.exchangeSession(sessionId);
        if (data?.session_token) {
          try {
            localStorage.setItem("session_token", data.session_token);
          } catch (err) {
            // localStorage can fail in private/incognito or when storage is full —
            // the httpOnly cookie will still carry the session so this is non-fatal.
            logger.warn("Could not persist session_token to localStorage", err);
          }
        }
        if (data?.user) setUser(data.user);
        // Scrub the URL fragment and land on dashboard
        navigate("/dashboard", { replace: true });
      } catch (e) {
        logger.error("Auth exchange failed", e);
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-[var(--bg-deep)] text-[var(--text-primary)] flex items-center justify-center" data-testid="auth-callback">
      <div className="flex items-center gap-3 text-[var(--text-muted)] text-sm">
        <span className="inline-block w-2 h-2 bg-[#E82127] rounded-full animate-pulse" />
        Signing you in…
      </div>
    </div>
  );
}
